const stripHtmlToText = (value) => {
  const html = String(value || "");
  const withoutTags = html.replace(/<[^>]*>/g, " ");
  return withoutTags.replace(/\s+/g, " ").trim();
};

const clamp = (text, maxLen) => {
  const s = String(text || "");
  if (!maxLen || s.length <= maxLen) return s;
  return s.slice(0, maxLen - 1).trimEnd() + "…";
};

export const getSiteOrigin = () => {
  const env = String(process.env.REACT_APP_SITE_ORIGIN || "").trim();
  if (env) return env.replace(/\/$/, "");
  if (typeof window !== "undefined" && window.location?.origin) return window.location.origin;
  return "https://cherrfy.com";
};

export const toAbsoluteUrl = (maybeUrl) => {
  const raw = String(maybeUrl || "").trim();
  if (!raw) return "";
  if (/^https?:\/\//i.test(raw)) return raw;
  const origin = getSiteOrigin();
  if (raw.startsWith("/")) return `${origin}${raw}`;
  return `${origin}/${raw}`;
};

export const buildCanonicalUrl = (pathname, search = "") => {
  const origin = getSiteOrigin();
  const path = String(pathname || "/");
  const raw = String(search || "");

  // Strip common tracking params to avoid duplicate canonical URLs.
  let cleaned = "";
  try {
    const params = new URLSearchParams(raw.startsWith("?") ? raw.slice(1) : raw);
    [
      "utm_source",
      "utm_medium",
      "utm_campaign",
      "utm_term",
      "utm_content",
      "gclid",
      "fbclid",
      "mc_cid",
      "mc_eid",
    ].forEach((k) => params.delete(k));
    const s = params.toString();
    cleaned = s ? `?${s}` : "";
  } catch {
    cleaned = "";
  }

  return `${origin}${path}${cleaned}`;
};

export const buildMetaDescription = (value, fallback) => {
  const text = stripHtmlToText(value);
  const finalText = text || String(fallback || "");
  return clamp(finalText, 160);
};
